import React from "react";
import Logo from "../../../components/Layout/Logo";
import "../auth.css";

interface AuthLayoutProps {
  /** Card heading */
  title: string;
  /** One line under the heading, optional */
  subtitle?: React.ReactNode;
  /** Wider card for forms with more fields (sign up) */
  wide?: boolean;
  children: React.ReactNode;
}

/**
 * Shared frame for the signed-out pages: brand logo above one card on the page background,
 * the same arrangement as the account emails.
 */
const AuthLayout: React.FC<AuthLayoutProps> = ({ title, subtitle, wide = false, children }) => (
  <div className="auth-page">
    <div className="auth-logo">
      <Logo height="5.5rem" />
    </div>
    <section className={`card auth-card${wide ? " auth-card-wide" : ""}`} aria-labelledby="auth-title">
      <div className="auth-heading">
        <h1 className="auth-title" id="auth-title">{title}</h1>
        {subtitle && <p className="auth-subtitle">{subtitle}</p>}
      </div>
      {children}
    </section>
  </div>
);

export default AuthLayout;
